import { DocumentMapping } from "@/configuration/document-mappings/types";
import { ENTS_REFERRAL_ASSIGNEE } from "@/configuration/groups/ents/configuration";
import { ConfigSubdomain } from "@/configuration/tenant-ids";
import { getClassificationDisplay } from "@/src/lib/utils/classification";
import { Classification } from "@/src/models/constants/classifications";

export const ENTS_MAPPINGS: Partial<Record<Classification, DocumentMapping>> = {
  [Classification.REFERRAL]: {
    group: ConfigSubdomain.ENT_PARTNERS_ENTS,
    classification: Classification.REFERRAL,
    displayName: getClassificationDisplay(Classification.REFERRAL, true),
    assignedTo: ENTS_REFERRAL_ASSIGNEE,
    folder: "Referral",
    folderMapping: "Referral",
    markAsReviewed: true,
    workflowType: "Inbound Referral WF (Lite)",
    inputDate: "",
    workflowAction: null,
    additionalWorkflow: null,
    documentLabel: "{{ dateOfReferral }} Referral to {{ serviceLine }}",
    instructions: null,
    accountId: null,
    accountLastName: null,
    accountFirstName: null,
  },
};
